import { withCurrentParams } from 'actions/utils';
import { BROADCAST_STOP_STREAMS } from 'actions/Types';

export default endpoints => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_STOP_STREAMS,
      request: async apiClient => {
        const response = await apiClient.broadcast.stopStreams(
          teamId,
          eventId,
          broadcastId,
          {
            endpoints
          }
        );

        /**
         * Handling this here because: 1: the api return the whole endpoint list as opposed to the stopped ones
         * 2: Middlware wont be able to target the stopped endpoint
         * Disabling the stopped endpoints until the task cleanup is done
         * We know the task cleanup in the processRealTimeMessage socket handler
         * TODO: Remedy this in a follow up issue
         */
        const result = response.endpoints.map(stEp => {
          if (endpoints.includes(stEp._id)) {
            return {
              ...stEp,
              canStartStream: false
            };
          }
          return stEp;
        });

        return {
          endpoints: result
        };
      }
    };
    dispatch(action);
  });
};
